import React from 'react';

export type BadgeVariant = 'ok' | 'warn' | 'err' | 'info' | 'emerald';
export type BadgeSize = 'sm' | 'md';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
  children?: React.ReactNode;
}

export function Badge({
  variant = 'info',
  size = 'md',
  children,
  className = '',
  ...props
}: BadgeProps) {
  const sizeStyles =
    size === 'sm'
      ? 'px-2 py-0.5 text-[10.5px]'
      : 'px-2.5 py-1 text-xs';

  let variantStyles = 'bg-blue-500/10 text-blue-500 border-blue-500/20';
  if (variant === 'ok') {
    variantStyles = 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20';
  } else if (variant === 'warn') {
    variantStyles = 'bg-amber-500/10 text-amber-500 border-amber-500/20';
  } else if (variant === 'err') {
    variantStyles = 'bg-red-500/10 text-red-500 border-red-500/20';
  } else if (variant === 'info') {
    variantStyles = 'bg-blue-500/10 text-blue-500 border-blue-500/20';
  } else if (variant === 'emerald') {
    variantStyles = 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30 font-semibold';
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium transition-colors ${sizeStyles} ${variantStyles} ${className}`}
      {...props}
    >
      {variant === 'emerald' && (
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
        </span>
      )}
      {children}
    </span>
  );
}
